import { queryOptions } from '@tanstack/react-query'
import { z } from 'zod'

import { percentageAboveOneSchema } from '../../../../../domain/common/validation'
import { TokenSymbol } from '../../../../../domain/types/TokenSymbol'
import { blockAnaliticaApiUrl } from '@/config/consts'

// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
function gnosisHistoricDataQueryOptions(symbol: TokenSymbol) {
  return queryOptions({
    queryKey: ['market-historic-data', 'gnosis', symbol],
    queryFn: async () => {
      const res = await fetch(`${blockAnaliticaApiUrl}/v1/gnosis/markets/${symbol}/historic-details/?days_ago=365`)
      const data = await res.json()
      const parsedData = baResponseSchema.parse(data)
      return parsedData.map((item) => ({
        date: item.dt,
        supplyRate: item.supply_rate,
        borrowRate: item.borrow_rate,
      }))
    },
  })
}

const baResponseSchema = z.array(
  z.object({
    dt: z.string().transform((value) => new Date(value)),
    supply_rate: percentageAboveOneSchema,
    borrow_rate: percentageAboveOneSchema,
  }),
)

// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
export function historicSupplyRateGnosisQueryOptions(symbol: TokenSymbol) {
  return queryOptions({
    ...gnosisHistoricDataQueryOptions(symbol),
    select: (data) =>
      data.map((item) => ({
        date: item.date,
        rate: item.supplyRate,
      })),
  })
}

// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
export function historicBorrowRateGnosisQueryOptions(symbol: TokenSymbol) {
  return queryOptions({
    ...gnosisHistoricDataQueryOptions(symbol),
    select: (data) =>
      data.map((item) => ({
        date: item.date,
        rate: item.borrowRate,
      })),
  })
}
